module.exports = __webpack_public_path__ + "9788f41e/img/product-icon-grey.b248963c.svg";